export default {
    localStorageFile(keyname, blob) {
        // Convert in Base 64
        var reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onloadend = function() {
            localStorage.setItem(keyname, reader.result)
        }
    },

    async convertBase64ToBlob(b64) {
        let response = await fetch(b64).then(res => res.blob())
        let url = URL.createObjectURL(response)
        return {
            blob: response,
            url: url
        }
    },

    transformKeyname(keyname) {
        return 'form_mobi_image_' + keyname
    },

    storeImage(keyname, blob) {
        this.localStorageFile(this.transformKeyname(keyname), blob)
    },

    async getImage(keyname) {
        if (localStorage.getItem(this.transformKeyname(keyname))) {
            let res = await this.convertBase64ToBlob(localStorage.getItem(this.transformKeyname(keyname)))
            return res
        }
    }
}
